if (!customElements.get('popup-wrapper')) {
  class Popup extends HTMLElement {
    constructor() {
      super();

      this.closeButton = this.querySelector('[data-popup-close]');
      this.popupLinks = document.querySelectorAll('[data-popup-link]');

      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.closePopup.bind(this));
      }

      document.addEventListener('keydown', (event) => {
        if (event.keyCode !== 27) { return; }

        this.closePopup();
      });

      document.addEventListener('click', this.openPopup.bind(this));
    }

    openPopup(event) {
      if (!event.target.hasAttribute('data-popup-link')) { return; }

      const popupId = event.target.getAttribute('data-popup-link');

      if (this.getAttribute('data-popup-id') !== popupId) { return; }

      this.classList.add('active');

      document.body.classList.add('popup-active');

      if (window.innerWidth >= 1025) {
        document.body.classList.add('overflow-hidden');
      } else {
        window.scrollLock();
      }

      setTimeout(() => {
        window.trapFocus(this);
      }, 100);
    }

    closePopup() {
      this.classList.remove('active');

      document.body.classList.remove('popup-active');

      if (window.innerWidth >= 1025) {
        document.body.classList.remove('overflow-hidden');
      } else {
        window.removeScrollLock();
      }

      window.removeTrapFocus();
    }
  }

  customElements.define('popup-wrapper', Popup);
}